import { Component } from 'react';
import { ILobbyState } from '../../../Core/State/ILobbyState';
import { IRoomState } from '../../../Core/State/IRoomState';
import { IUserState } from '../../../Core/State/IUserState';
import styles from '../../../assets/css/components/MobileLobby.module.css';
import { createTheme, Stack, ThemeProvider } from '@mui/material';
import MobileHeader from '../../Header/MobileHeader';
import MobileRoomBar from '../../RoomBar/MobileRoomBar';
import MobileTableRow from '../Common/MobileTableRow';

// Table images for pre-loading purposes
import auraTable from '/images/table/mobile-game-table-aura.svg';
import bnbTable from '/images/table/mobile-game-table-bnb.svg';
import busdTable from '/images/table/mobile-game-table-busd.svg';
import daiTable from '/images/table/mobile-game-table-dai.svg';
import dogeTable from '/images/table/mobile-game-table-doge.svg';
import dotTable from '/images/table/mobile-game-table-dot.svg';
import kltvTable from '/images/table/mobile-game-table-kltv.svg';
import oplTable from '/images/table/mobile-game-table-opl.svg';
import shibTable from '/images/table/mobile-game-table-shib.svg';
import solTable from '/images/table/mobile-game-table-sol.svg';
import solamaTable from '/images/table/mobile-game-table-solama.svg';
import usdcTable from '/images/table/mobile-game-table-usdc.svg';
import usdtTable from '/images/table/mobile-game-table-usdt.svg';
import vlxTable from '/images/table/mobile-game-table-vlx.svg';
import xmrTable from '/images/table/mobile-game-table-xmr.svg';

interface LobbyProps {
    joinRoom: (roomId: string) => void;
    setSection: (section: string) => void;
    userState: IUserState;
    lobbyState: ILobbyState;
    selectedRoomId: string | null;
    section: string;
    joinedRoomsState: any[];
    logout: () => void;
    userConnectedCount: number;
}

interface LobbyState {
    selectedRoom: IRoomState | null;
}

export default class MobileCryptoLobby extends Component<LobbyProps, LobbyState> {

    constructor(props: LobbyProps) {
        super(props);
        this.state = {
            selectedRoom: null
        };
    }

    darkTheme = createTheme({
        palette: {
            mode: "dark",
            primary: {
                main: "#F93751",
            },
        },
        typography: {
            fontFamily: 'Inter, serif',
        },
    });

    componentDidMount(): void {
        // Preload table images
        const tableImages = [auraTable, bnbTable, busdTable, daiTable, dogeTable, dotTable, kltvTable, oplTable, shibTable, solTable, solamaTable, usdcTable, usdtTable, vlxTable, xmrTable];
        tableImages.forEach((image: string) => {
            const img = new Image();
            img.src = image;
        });
    }

    componentDidUpdate(prevProps: LobbyProps) {
        if (this.state.selectedRoom && prevProps.lobbyState !== this.props.lobbyState) {
            const updatedRoom = this.props.lobbyState.rooms.find(room => room.roomId === this.state.selectedRoom?.roomId);
            if (updatedRoom) {
                this.setState({ selectedRoom: updatedRoom });
            }
        }
    }

    render() {
        // Update the filtering to only show aof rooms
        const filteredRooms = this.props.lobbyState.rooms.filter(room => 
            room.type === 'aof' && room.currencyType === 'crypto'
        );
        // Sort rooms by playerSatCount, descending
        filteredRooms.sort((a, b) => b.playerSatCount - a.playerSatCount);

        return (
            <ThemeProvider theme={this.darkTheme}>
                <Stack className={styles.mobileLobby}>
                    <MobileHeader 
                        userState={this.props.userState}
                        section={this.props.section}
                        logout={this.props.logout}
                    />
                    <MobileRoomBar
                        userConnectedCount={this.props.userConnectedCount}
                    />
                    <Stack spacing={1} className={styles.mobileLobbyTables}>
                        {filteredRooms.map((table) => (
                            <MobileTableRow key={table.roomId} table={table} joinedRoomsState={this.props.joinedRoomsState} joinRoom={this.props.joinRoom} userState={this.props.userState} />
                        ))}
                    </Stack>
                </Stack>
            </ThemeProvider>
        );
    }
}
